import { AnyAction } from "redux";
import { OrgLicenseAccess, LicensePlan } from "../actions/PlanActions";

/* ─────────────────────────────────────────────────────────
   Action Types
   ───────────────────────────────────────────────────────── */
export const SET_LICENSE_ACCESS = "SET_LICENSE_ACCESS";
export const CLEAR_LICENSE_ACCESS = "CLEAR_LICENSE_ACCESS";
export const SET_AVAILABLE_PLANS = "SET_AVAILABLE_PLANS";

/* ─────────────────────────────────────────────────────────
   State
   ───────────────────────────────────────────────────────── */
export interface LicenseReducerState {
  access: OrgLicenseAccess | null;
  plans: LicensePlan[];
  addons: LicensePlan[];
  loaded: boolean;
}

const initialState: LicenseReducerState = {
  access: null,
  plans: [],
  addons: [],
  loaded: false,
};

/* ─────────────────────────────────────────────────────────
   Reducer
   ───────────────────────────────────────────────────────── */
export const licenseReducer = (
  state = initialState,
  action: AnyAction
): LicenseReducerState => {
  switch (action.type) {
    case SET_LICENSE_ACCESS:
      return { ...state, access: action.payload, loaded: true };
    case SET_AVAILABLE_PLANS:
      return {
        ...state,
        plans: action.payload.plans,
        addons: action.payload.addons,
      };
    case CLEAR_LICENSE_ACCESS:
      return initialState;
    default:
      return state;
  }
};
